import React from "react";
import { Typography, TextField } from "@mui/material";

const CakeSeoFields = ({ seo, onChange }) => (
  <>
    <Typography mt={4} fontWeight={700}>
      SEO Fields
    </Typography>
    <TextField
      label="Meta Title"
      fullWidth
      margin="dense"
      value={seo.metaTitle}
      onChange={(e) => onChange({ ...seo, metaTitle: e.target.value })}
    />
    <TextField
      label="Meta Description"
      fullWidth
      margin="dense"
      value={seo.metaDescription}
      onChange={(e) => onChange({ ...seo, metaDescription: e.target.value })}
    />
    <TextField
      label="Meta Keywords"
      fullWidth
      margin="dense"
      value={seo.metaKeywords}
      onChange={(e) => onChange({ ...seo, metaKeywords: e.target.value })}
    />
  </>
);

export default CakeSeoFields;
